var _class;
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _applyDecoratedDescriptor(i, e, r, n, l) {
  var a = {};
  return Object.keys(n).forEach(function (i) {
    a[i] = n[i];
  }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) {
    return n(i, e, r) || r;
  }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a;
}
import { registerDestructor } from "@ember/destroyable";
import { cancel } from "@ember/runloop";
import Modifier from "ember-modifier";
import discourseLater from "discourse-common/lib/later";
import { bind } from "discourse-common/utils/decorators";
const CSS_TRANSITION_DELAY_MS = 300;
const TRANSITION_CLASS = "-fade-out";
let AutoCloseToast = (_class = class AutoCloseToast extends Modifier {
  constructor(owner, args) {
    super(owner, args);
    _defineProperty(this, "element", void 0);
    _defineProperty(this, "close", void 0);
    _defineProperty(this, "duration", void 0);
    _defineProperty(this, "transitionLaterHandler", void 0);
    _defineProperty(this, "closeLaterHandler", void 0);
    _defineProperty(this, "progressBar", void 0);
    _defineProperty(this, "progressAnimation", void 0);
    _defineProperty(this, "enabled", void 0);
    registerDestructor(this, instance => instance.cleanup());
  }
  modify(element, _, _ref) {
    let {
      close,
      duration,
      progressBar,
      enabled
    } = _ref;
    if (enabled === false) {
      this.enabled = false;
      return;
    }
    this.element = element;
    this.close = close;
    this.duration = duration;
    this.timeRemaining = duration;
    this.progressBar = progressBar;
    this.element.addEventListener("touchstart", this.stopTimer, {
      passive: true,
      once: true
    });
    this.element.addEventListener("mouseenter", this.stopTimer, {
      passive: true
    });
    this.element.addEventListener("mouseleave", this.startTimer, {
      passive: true
    });
    this.startTimer();
  }
  startTimer() {
    this.startProgressAnimation();
    this.transitionLaterHandler = discourseLater(() => {
      this.element.classList.add(TRANSITION_CLASS);
      this.closeLaterHandler = discourseLater(() => {
        this.close();
      }, CSS_TRANSITION_DELAY_MS);
    }, this.timeRemaining);
  }
  stopTimer() {
    this.pauseProgressAnimation();
    cancel(this.transitionLaterHandler);
    cancel(this.closeLaterHandler);
  }
  startProgressAnimation() {
    if (!this.progressBar) {
      return;
    }
    if (this.progressAnimation) {
      this.progressAnimation.play();
      this.progressBar.style.opacity = 1;
      return;
    }
    this.progressAnimation = this.progressBar.animate({
      transform: `scaleX(0)`
    }, {
      duration: this.duration,
      fill: "forwards"
    });
  }
  pauseProgressAnimation() {
    if (!this.progressAnimation || this.progressAnimation.currentTime === this.duration) {
      return;
    }
    this.progressAnimation.pause();
    this.progressBar.style.opacity = 0.5;
    this.timeRemaining = this.duration - this.progressAnimation.currentTime;
  }
  cleanup() {
    if (!this.enabled) {
      return;
    }
    this.stopTimer();
    this.element.removeEventListener("mouseenter", this.stopTimer);
    this.element.removeEventListener("mouseleave", this.startTimer);
    this.progressBar = null;
  }
}, (_applyDecoratedDescriptor(_class.prototype, "startTimer", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "startTimer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stopTimer", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "stopTimer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "startProgressAnimation", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "startProgressAnimation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pauseProgressAnimation", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "pauseProgressAnimation"), _class.prototype)), _class);
export { AutoCloseToast as default };